import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconInfo } from '@redteclab/icons'

import { useOpenableControls } from '../../../../generic-hooks'
import { RedPointsBenefitDialog } from '../../../../redpoints'
import { ProductSearchFlag } from '../../ProductSearchFlag'

import { type ProductSearchResultItemLabel } from './useProductSearchResultItemLabels'

export const ProductSearchResultItemRedPointsLabel: FC<{
  label: ProductSearchResultItemLabel
}> = ({ label }) => {
  const multiplier = label.redPointsMultiplierSpecific?.multiplier
  const modalControls = useOpenableControls()

  if (!multiplier) {
    return null
  }

  return (
    <>
      <ProductSearchFlag
        className="border-light-primary-strong bg-light-primary-medium"
        data-qa-id="form-red-points-modal-button"
        onClick={modalControls.handleOpen}
        slots={{
          root: 'button',
        }}
        type="button"
      >
        <>
          {multiplier}
          {'x '}
          <FormattedMessage id="general.label.redPoints" />
          <IconInfo className="ml-1 size-4" />
        </>
      </ProductSearchFlag>
      <RedPointsBenefitDialog
        isOpen={modalControls.isOpen}
        onClose={modalControls.handleClose}
      />
    </>
  )
}
